import React from 'react';
import { reactDnD } from '@yola/ws-ui';
import PropTypes from 'prop-types';
import constants from '../constants';
import GalleryDragItemPreview from './gallery-drag-item-preview';

const { useDragLayer } = reactDnD;

function getPreviewPositioning(initialOffset, currentOffset) {
  const transform = `translate3d(${currentOffset.x - initialOffset.x}px, ${
    currentOffset.y - initialOffset.y
  }px, 0px)`;

  return {
    top: initialOffset.y,
    left: initialOffset.x,
    transform,
  };
}

function getPreviewItemPositioning(previewStackOrder) {
  const stackOffset = 8;
  return {
    position: `absolute`,
    top: `${previewStackOrder * stackOffset}px`,
    left: `${previewStackOrder * stackOffset}px`,
  };
}

function GalleryDragPreviewLayer({ previewsStackLength = 2, placeholderType = null }) {
  const { draggedItemsData, initialOffset, currentOffset, itemType } = useDragLayer((monitor) => {
    const draggingData = monitor.getItem();
    return {
      initialOffset: monitor.getInitialSourceClientOffset(),
      itemType: monitor.getItemType(),
      currentOffset: monitor.getSourceClientOffset(),
      draggedItemsData: draggingData?.draggedItemsData,
    };
  });

  if (
    !draggedItemsData ||
    !draggedItemsData.length ||
    !currentOffset ||
    itemType !== constants.dnd.DRAG_ITEM
  ) {
    return null;
  }

  // Reverse sorted items to render them using
  // natural stacking context without z-indexes
  const draggedItemsDataPrepared = draggedItemsData
    .sort((a, b) => a.previewStackOrder - b.previewStackOrder)
    .slice(0, previewsStackLength)
    .reverse();

  return (
    <div
      className="ws-gallery-item ws-gallery-item--drag-preview"
      style={{ ...getPreviewPositioning(initialOffset, currentOffset) }}
    >
      {draggedItemsDataPrepared.map((item) => (
        <GalleryDragItemPreview
          key={item.id}
          src={item.src}
          width={item.width}
          order={item.order}
          style={{ ...getPreviewItemPositioning(item.previewStackOrder) }}
          isPlaceholder={item.isPlaceholder}
          placeholderType={placeholderType}
          mediaType={item.mediaType}
        />
      ))}
    </div>
  );
}

GalleryDragPreviewLayer.propTypes = {
  placeholderType: PropTypes.string,
  previewsStackLength: PropTypes.number,
};

export default GalleryDragPreviewLayer;
